// TODO: columns selection of event participants in cms: width and z-index problem after table reSort!

const orientationMatrix = [
	'C',
	'N',
	'NE',
	'E',
	'SE',
	'S',
	'SW',
	'W',
	'NW'
];

module.exports = {
	config: {
		type: '',
		focusAble: true,
		environmentDependent: true,
		clickable: true,
		clickableOnly: false,
		autoOpen: false,
		orientation: 'N',
		// C, N, NE, E, SE, S, SW, W, NW
		// NOTE: NE stands for north-east and means that the popover-content will appear with its south-west corner at the north-east corner of the popover-trigger.
		// NOTE: you may influence the opposite corner as well. you only need to add an extra orientation separated by minus. e.g., NE equals NE-SW
		// NOTE: there is an extra orientation called CORE (C) which means the geometric center of the elements. e.g., C equals C-C
		distance: {
			x: 0,
			y: 0
		},
		// the popover position calculations assume that the content is rendered left aligned and right below the trigger.
		// however, it is sometimes necessary to style the trigger in a different way which leads to a different content base position.
		// e.g., if the trigger has to be css:position:absolute the content would be rendered so that the left upper corner of trigger and content are at the exact same position.
		// therefor, one may define this triggerOffset in x and y direction (percent of width and height of the trigger from 0 => 0% to 1 => 100%) to match the correct starting position for the calculations of the content.
		// the content has to be located at the trigger's lower left corner, so the position calculations are correct.
		triggerOffset: {
			x: 0,
			y: 0
		},

		prepareEmpty: false, // sometimes one want a popover to be instanced at runtime according to some user-actions.
		preventFirstFocusOut: false, // prevent hiding an autoShown popover on focus out after init
	},

	model: {
		active: false,
		persistentActive: false,
		internal: {
			triggerDimensions: {},
			contentDimensions: {}
		}
	},

	events: {
		show: {
			type: 'mouseenter',
			selector: '.popover_trigger',
			action: function(event){
				const self = event.data.component;
				if(!self.config.clickableOnly){
					self.show();
				}
			}
		},

		hide: {
			type: 'mouseleave',
			selector: '.popover_trigger',
			action: function(event){
				const self = event.data.component;
				if(!self.config.clickableOnly) {
					self.hide();
				}
			}
		},

		togglePersistent: {
			type: 'click',
			action: function(event){
				const self = event.data.component;
				if(self.config.clickable){
					event.stopImmediatePropagation();

					const $target = $(event.target).closest('.popover_trigger');
					if($target.length > 0){
						if(self.model.persistentActive){
							self.hide(true);
						}
						else {
							self.show(true);
						}
					}
				}
			}
		},

		hidePersistent: {
			type: 'focusout',
			selectorAddSelf: true,
			selector: '*',
			action: function(event){
				const self = event.data.component;
				if(event.relatedTarget === null || self.$.has($(event.relatedTarget)).length <= 0 && !self.$.is($(event.relatedTarget))){
					if(self.model.persistentActive){
						if(self.config.preventFirstFocusOut){
							self.$.focus();
							self.config.preventFirstFocusOut = false
						} else {
							self.hide(true);
						}
					}
				}
			}
		},
	},

	methods: {
		show: function(persistent){
			if(persistent){
				this.model.persistentActive = true;
			}
			if(!this.model.active){
				this.model.active = true;
				this.$.addClass('active');
				this.onShow();
			}
			if(persistent){
				this.$.focus();
			}
		},

		hide: function(persistent){
			if(persistent || !this.model.persistentActive){
				this.model.persistentActive = false;
				if(this.model.active){
					this.model.active = false;
					this.$.removeClass('active');
					this.onHide();
				}
			}
		},

		toggle: function(persistent){
			if(this.model.active){
				this.hide(persistent);
			} else {
				this.show(persistent);
			}
		},

		onShow: function(){},
		onHide: function(){},

		refreshTrigger: function(){
			if(this.model.triggerComponent){
				// popovers state may be changed, so update trigger components data
				this.model.triggerComponent.resourceData 	= this.resourceData;
				this.model.triggerComponent.model 			= this.model;
				this.model.triggerComponent.config.type 	= this.config.type;

				// some model flags may overwrite config flags
				if(this.model.orientation)	this.config.orientation = this.model.orientation
				if(this.model.distance) 	this.config.distance 	= this.model.distance

				this.model.triggerComponent.refresh(false);
			}
		},

		refreshDimensions: function(){
			if(!this.$) return;

			const $trigger = this.$.find('.popover_trigger');
			const $content = this.$.find('.popover_content').css({
				width: 'auto',
				height: 'auto',
				transform: 'unset',
				left: 'unset',
				right: 'unset',
			});

			this.$.addClass('activeMeasurement')
			const triggerDimensions = this.model.internal.triggerDimensions = {
				w: $trigger.outerWidth(),
				h: $trigger.outerHeight()
			};

			const deltas = {
				trigger: {
					x: 0,
					y: 0
				},
				content: {
					x: 0,
					y: 0
				}
			};

			// some model flags may overwrite config flags
			if(this.model.orientation)	this.config.orientation = this.model.orientation
			if(this.model.distance) 	this.config.distance 	= this.model.distance

			let orientation = String(this.config.orientation).split('-');
			orientation = {
				trigger: String(orientation[0]).toUpperCase(),
				content: String(orientation[1] || '').toUpperCase()
			};

			if(orientation.content === ''){
				if(orientation.trigger === 'C') {
					orientation.content = 'C';
				} else if((orientationMatrix.indexOf(orientation.trigger) + 4) > 8){
					orientation.content = orientationMatrix[(orientationMatrix.indexOf(orientation.trigger) - 4)];
				} else {
					orientation.content = orientationMatrix[(orientationMatrix.indexOf(orientation.trigger) + 4)];
				}
			}

			// trigger x
			if(orientation.trigger.indexOf('W') > -1) {
				deltas.trigger.x = 0;
			} else if(orientation.trigger.indexOf('E') > -1){
				deltas.trigger.x = 1;
			} else {
				deltas.trigger.x = 0.5;
			}
			// add trigger offset if necessary
			deltas.trigger.x += this.config.triggerOffset.x

			// trigger y
			if(orientation.trigger.indexOf('N') > -1) {
				deltas.trigger.y = -1;
			} else if(orientation.trigger.indexOf('S') > -1){
				deltas.trigger.y = 0;
			} else {
				deltas.trigger.y = -0.5;
			}
			// add trigger offset if necessary
			deltas.trigger.y += this.config.triggerOffset.y

			// content x
			if(orientation.content.indexOf('W') > -1){
				deltas.content.x = 0;
				$content.css({
					left: 0,
				})
			} else if(orientation.content.indexOf('E') > -1){
				deltas.content.x = -1;
				$content.css({
					right: 0,
				})
			} else {
				deltas.content.x = -0.5;
			}

			// content y
			if(orientation.content.indexOf('N') > -1){
				deltas.content.y = 0;
			} else if(orientation.content.indexOf('S') > -1){
				deltas.content.y = -1;
			} else {
				deltas.content.y = -0.5;
			}

			const triggerLeftParts = [(deltas.trigger.x * triggerDimensions.w) + 'px']
			const triggerTopParts = [(deltas.trigger.y * triggerDimensions.h) + 'px']
			if(this.config.distance.x){
				if(deltas.trigger.x === 0 && deltas.content.x === -1){
					triggerLeftParts.push(`-${this.config.distance.x}`)
				} else if(deltas.trigger.x === 1 && deltas.content.x === 0){
					triggerLeftParts.push(this.config.distance.x)
				}
			}
			if(this.config.distance.y){
				if(deltas.trigger.y === 0 && deltas.content.y === 0){
					triggerTopParts.push(this.config.distance.y)
				} else if(deltas.trigger.y === -1 && deltas.content.y === -1){
					triggerTopParts.push(`-${this.config.distance.y}`)
				}
			}

			$content.css({
				'margin-left': `calc(${triggerLeftParts.join(' + ')})`,
				'margin-top': `calc(${triggerTopParts.join(' + ')})`,
			});

			const contentDimensions = this.model.internal.contentDimensions = {
				w: $content.outerWidth(),
				h: $content.outerHeight()
			};

			// prevent blurry problems when using translate3d
			let width = parseInt(contentDimensions.w);
			let height = parseInt(contentDimensions.h);
			if(width < contentDimensions.w) 	width++;
			if(height < contentDimensions.h) 	height++;
			if((width % 2) > 0) 	width++;
			if((height % 2) > 0) 	height++;

			this.$.removeClass('activeMeasurement')

			$content.css({
				'transform': 'translate3d(' + (deltas.content.x * 100) + '%, ' + (deltas.content.y * 100) + '%, 0)',
				'width': width,
				'height': height,
				left: 'unset',
				right: 'unset',
			});
		},

		onEnvironmentUpdated(){
			this.refreshDimensions()
		},
	},

	hooks: {
		postAttach: function($element, options){
			const self = this;

			this.refreshDimensions()

			if(!options.refresh && this.config.autoOpen){
				this.show(this.config.clickableOnly);
			}
			else if (this.model.active){
				this.$.focus();
			}

			if(!this.model.triggerComponent){
				let $potentialTriggerComponent;
				if(($potentialTriggerComponent = this.$.find('> .container > .popover_trigger > [data-component-index]')).length > 0){
					self.model.triggerComponent = getComponent($potentialTriggerComponent);
				}
			}
		},

		// modals have to wait until their content components has been loaded, prepared and rendered.
		// it is possible that the dimensions could not be calculated since the popover was not visible at the point in time when the attach-hook has been executed.
		modalAttached: function($element, options){
			if(this.model.internal.contentDimensions.w < 1 || this.model.internal.contentDimensions.h < 1){
				this.refreshDimensions();
			}
		},

		// tabContents have to wait until their content components has been loaded, prepared and rendered.
		// it is possible that the dimensions could not be calculated since the popover was not visible at the point in time when the attach-hook has been executed.
		postTabFocus: function($element, options){
			if(this.model.internal.contentDimensions.w < 1 || this.model.internal.contentDimensions.h < 1){
				this.refreshDimensions();
			}
		},

		// children might actively change their dimensions
		refreshDimensions: function($element, options){
			this.refreshDimensions();
		}
	}
}
